export default {
  AVAILABLE_VALUES: `Options disponibles : `,
  CURRENT_FILTER: `Filtre actuel`,
  ABSENCE_REASON: `Raison d'absence`,
  FILTERS: `Filtres`,
  APPROVAL_REQUIRED: `Approbation requise`,
  APPROVED: `Approuvé`,
  ARCHIVED_PROJECTS: `Projets archivés`,
  ARCHIVED_TEMPLATES: `Modèles archivés`,
  ASKED_FOR_CHANGES: `A demandé des changements`,
  NOT_ONBOARDED: `Aucune invitation`,
  NEVER_CONNECTED: `Aucune connexion`,
  ATTRIBUTE_TYPES: `Type d'attributs`,
  ATTRIBUTES: `Attribut`,
  BLOCKED: `bloqué`,
  CANCEL: `Annuler`,
  CANCELLED: `Quarts annulés`,
  CANNOTBESELFASSIGNED: `Ne peut pas être auto-assigné`,
  CHECK_ONLY_TIME_OFF: `Limiter à un type de congé`,
  CHECK_ONLY: `Verifier seulement {{ name }}`,
  CLIENTS: `Client`,
  CUSTOMTAG: `Étiquette personnalisée`,
  CLIENT_SENIORITIES: `Ancienneté par client`,
  POSITION_SENIORITIES: `Ancienneté par position`,
  CONTACT_LIST_STATUS: `Statut de la liste`,
  CONTACT_USER_FLAG: `Indicateurs de contact`,
  CONTRACT_TYPE: `Contrat`,
  CREATED_BY_LABEL: `Crée par {{ fullName }} ({{ employeeNumber }})`,
  CREATED_BY: `Créé par`,
  CURRENTLY_CALLING: `Appel en cours`,
  CUSTOM: `Dates personnalisées`,
  DATES: `Dates`,
  DEPARTMENT: `Département`,
  DONT_CHECK_TIME_OFF: `Ignorer certains types de congé`,
  DONT_CHECK: `Ignorer les {{ name }}`,
  EARLY_OUT_REASON: `Raison de départ hâtif`,
  EARLY_OUT_TYPE: `Départ hâtif`,
  EARNING_CODE: `Code de gain`,
  ELIGIBLE_FOR: `Éligible pour {{ position }}`,
  EMPLOYEE_TYPE: `Type d'employé`,
  FILTER_REQUESTS_ABSENCE: `Absences`,
  FILTER_REQUESTS_ALL: `Toutes les requêtes d'absence`,
  FILTER_REQUESTS_DELAY: `Retards`,
  FILTER_REQUESTS_EARLY_OUT: `Départs hâtifs`,
  FILTER_REQUESTS_VACATION: `Congés`,
  FINALIZED: `Quart Finalisé`,
  HAS_ISSUES: `A des problèmes`,
  HAS_COMMENTS: `A des commentaires`,
  HAS_TRANSFERS: `A des transferts`,
  HAS_NOT_ATTRIBUTE: `N'a pas {{ name }}`,
  HAS_NOT_DEPARTMENT: `N'est pas dans {{ name }}`,
  HAS_NOT_POSITION: `N'a pas {{ name }}`,
  HASSPECIFICREQUIREMENTS: `A des requis spécifiques`,
  HIDE_FINALIZED: `Cacher finalisé`,
  HIRING_DATA_TYPES: `Type de données d'embauche`,
  HIRING_DATA: "Donnée d'embauche",
  IS_ARCHIVED: `Est archivé`,
  IS_AVAILBLE: `Est disponible`,
  IS_ELIGIBLE: `Est eligible`,
  IS_NOT_ON_TIME_OFF: `N'est pas en congé cette journée`,
  IS_NOT_WORKING: `Ne travaille pas`,
  ISEXTRASHIFT: `Heure de fin variable`,
  ISIRREPLACEABLE: `Ne doit pas être remplacé`,
  ISOVERTIME: `Temps supplémentaire`,
  ISONCALL: `Sur appel`,
  LAST_SEVEN_DAYS: `7 derniers jours`,
  LAST_THIRTY_DAYS: `30 derniers jours`,
  LAST_365_DAYS: `Dernière année`,
  CURRENT_PAY_PERIOD: `Période de paye actuelle`,
  PREVIOUS_PAY_PERIOD: `Période de paye précédente`,
  LAST_WEEK: `Semaine dernière`,
  YESTERDAY: `Hier`,
  LATE_REASON: `Raison de retard`,
  LATE_TYPE: `Retard`,
  LEAVE_TYPE: `Absence`,
  LOCATION: `Emplacement`,
  LOCKED: `verrouillé`,
  MISSING_ATTRIBUTES: `Attribut manquant`,
  MISSING_DEPARTMENT: `Département manquant`,
  MISSING_POSITIONS: `Position manquante`,
  NEEDSREPLACEMENT: `Quart à combler`,
  COVEREDOTHERUNIT: `Couvert par une autre unité`,
  NO_CURRENT_FILTER: `Aucun filtre n'est actuellement défini`,
  NO_EMAIL_SET: `Aucune adresse courriel définie`,
  NO_EMAIL: `Aucune adresse courriel`,
  NO_FILTER_SAVED: `Aucune recherche n'a été sauvegardée.`,
  NO_PHONE_NUMBER_SET: `Aucun numéro de téléphone`,
  NO_PHONE_NUMBER: `Aucun numéro de téléphone`,
  NO_SAVED_PRESETS: `Aucune recherche sauvegardée`,
  NO_VACATION_DURING_WEEK: `N'est pas en congé cette semaine`,
  CHECK_PARTIAL_TIME_OFF_ONLY: `Prendre seulement les congés partiels en compte`,
  IGNORE_PARTIAL_TIME_OFF: `Ignorer les congés partiels`,
  NOEMPLOYEEAVAILABLE: `Aucun employé disponible`,
  NON_ASSIGNABLE: `Non assignable`,
  NOT_VALIDATED: `Invalidé`,
  NO_RESULTS: `Aucun résultat trouvé`,
  PERMIT_TYPE: `Permis`,
  POSITION: `Position`,
  PERMISSION: 'Permission',
  POSITIONS: `Position`,
  PERMISSIONS: 'Permissions',
  PREFERRED: `préféré`,
  PROJECT_BLOCKED: `Projet (bloqué de)`,
  PROJECT_CODE: `Code d'un projet`,
  PROJECT_LOCKED: `Projet (verrouillé dans)`,
  PROJECT_OWNER: `Chef de projet`,
  PROJECT_PREFERRED: `Projet (préféré sur)`,
  PROJECT_STATUS: `Statut de projet`,
  PROJECT_TAG: `Étiquette d'un projet`,
  PROJECT: `Projet`,
  PUNCH_FLAG: `Drapeau`,
  PUNCH_STATUS: `État de la carte de temps`,
  REGION: `Région`,
  REPLACED: `Quarts comblés`,
  REPORTS_TO: `Se rapporte à`,
  REPORTS_TO_NAME: `Se rapporte à {{ fullName }}`,
  REPORTS_TO_ME: `Se rapporte à moi`,
  REQUEST_FLAGS: `Avertissement`,
  REQUEST_OPTIONS_TYPES: `Type de raisons`,
  REQUEST_OPTIONS: `Raison des requêtes`,
  REQUEST_STATUS: `État de la demande`,
  REQUEST_TYPE: `Type de demande`,
  REQUIREMENT: `Exigence`,
  REQUIRES_ACTION: `Action nécessaire`,
  RESOURCES: `Ressource`,
  CONTEXTUAL_FILTERS: `Filtres contextuels`,
  RESTRICTION: `Restriction`,
  SAVE: 'Sauvegarder',
  SAVED_PRESET: `Recherche sauvegardée`,
  SAVED_PRESETS: `Recherches sauvegardées`,
  SCHEDULE_EVENT_FLAGS: "Indicateur d'un quart",
  SCHEDULE_MODIFICATIONS_REASONS: `Raisons de modification du quart`,
  SCHEDULE_TEMPLATES: `Modèle d'horaire`,
  SCHEDULE_TYPES: `Type d'horaire`,
  SEARCH: `Chercher`,
  SELECT: `Sélectionner`,
  SELECT_ALL: `Tout`,
  SELECT_NONE: `Aucun`,
  SELECT_DATES: `Filtrer par date`,
  SELFASSIGN: `Assignable par un employé`,
  SHIFTOPTIONS: `Option de quart`,
  SHOW_ABSENCES_OVER_THRESHOLD: `Afficher les absences au-dessus du seuil`,
  SHOW_INTEGRATION_ERRORS: `Afficher les erreurs d'intégration`,
  SHOW_ALL_POSITIONS: `Afficher toutes les positions`,
  SHOW_ALL_SCHEDULED_PROJECTS: `Afficher tous les projets à l'horaire`,
  SHOW_CANCELLED_ONLY: `Quarts annulés`,
  SHOW_FINALIZED: `Afficher finalisé`,
  SHOW_UNPUNCHED_SHIFTS: `Quarts non-poinçonnés`,
  NO_PROJECT: `Pas de projet assigné`,
  UNCONFIRMED_BY_USER: `L'employé n'a pas accusé réception`,
  SKILL: `Qualification`,
  SUMMARY: `Les préréglages vous permettent de sauvegarder les recherches que vous effectuez fréquemment afin de les retrouver facilement.`,
  TAGS_TYPES: `Type d'étiquettes`,
  TAGS: `Étiquettes`,
  TEAM: `Équipe`,
  TEMPLATE_NAME: `Nom du modèle `,
  TIME_OFF_TYPE: `Congé`,
  TITLE: `Recherche sauvegardée`,
  TODAY: `Aujourd'hui`,
  TYPE_TO_SEARCH: `Recherchez ici`,
  UNASSIGNED: `Quarts non assignés`,
  UNPUBLISHED_SHIFTS: `Quarts non publiés`,
  USER_ELIGIBLE_FOR_POSITION: `Éligible pour (nom de la position)`,
  USER_STATUS: `Statut d'utilisateur`,
  USER: `Utilisateur`,
  VACATION_TYPE: `Type de vacances`,
  VIEW_LESS: `Voir moins`,
  VIEW_MORE: `Voir plus`,
  WAGE_PREMIUMS: `Étiquettes de prime salariale`,
  ABSENCE_REASON_DESCRIPTION: "Permet de filtrer la recherche selon la raison de l'absence.",
  ARCHIVED_PROJECTS_DESCRIPTION: `Permet d'afficher les projets archivés.`,
  ARCHIVED_TEMPLATES_DESCRIPTION: `Permet de trouver les modèles archivés.`,
  ATTRIBUTE_TYPES_DESCRIPTION: `Permet de filtrer la recherche selon le type d'attribut.`,
  ATTRIBUTES_DESCRIPTION: `Permet de filtrer la recherche selon les attributs.`,
  CLIENT_DESCRIPTION: `Permet de filtrer la recherche selon les clients rattachés au projet.`,
  CONTACT_LIST_STATUS_DESCRIPTION: `Permet de filtrer la recherche selon le statut de la liste.`,
  CONTACT_USER_FLAG_DESCRIPTION: `Permet de filtrer la recherche selon les indicateurs de contact d'un utilisateur.`,
  CREATED_BY_DESCRIPTION: `Permet de filtrer la recherche selon des résultats créés par un utilisateur.`,
  DEPARTMENT_DESCRIPTION: `Permet de filtrer la recherche selon le département.`,
  EARLY_OUT_REASON_DESCRIPTION: `Permet de filtrer la recherche selon la raison du départ hâtif.`,
  FINALIZED_DESCRIPTION: `Permet de filtrer la recherche selon les quarts finalisés.`,
  HIRING_DATA_DESCRIPTION: "Permet de filtrer la recherche selon une donnée d'embauche.",
  HIRING_DATA_TYPES_DESCRIPTION: `Permet de filtrer selon les types de données d'embauche.`,
  IS_ARCHIVED_DESCRIPTION: `Chercher les utilisateurs archivés.`,
  LATE_REASON_DESCRIPTION: `Permet de filtrer la recherche selon la raison du retard.`,
  LOCATION_DESCRIPTION: "Permet de filtrer la recherche selon l'emplacement.",
  LOCATIONS_DESCRIPTION: "Permet de filtrer la recherche selon un emplacement d'arrivée et de départ.",
  MISSING_ATTRIBUTES_DESCRIPTION: `Permet de filtrer la recherche selon les attributs manquants.`,
  MISSING_DEPARTMENT_DESCRIPTION: `Permet de filtrer la recherche selon un département manquant.`,
  MISSING_POSITIONS_DESCRIPTION: `Permet de filtrer selon une position manquante.`,
  NAME_DESCRIPTION: `Le nom permettra d'identifier ce à quoi renvoie cette recherche.`,
  NO_EMAIL_DESCRIPTION: "Permet de trouver les utilisateurs n'ayant pas d'adresse courriel.",
  NO_PHONE_NUMBER_DESCRIPTION: "Permet de trouver les utilisateurs n'ayant pas de numéro de téléphone.",
  NOT_VALIDATED_DESCRIPTION: "Permet de trouver les utilisateurs n'ayant pas encore été validés.",
  POSITION_DESCRIPTION: `Permet de filtrer la recherche selon une position.`,
  POSITIONS_DESCRIPTION: `Permet de filtrer selon la position.`,
  PERMISSION_DESCRIPTION: `Permet de filtrer la recherche selon une permission.`,
  PERMISSIONS_DESCRIPTION: `Permet de filtrer selon la permission.`,
  PROJECT_BLOCKED_DESCRIPTION: `Permet de filtrer la recherche selon les utilisateurs bloqués d'un projet.`,
  PROJECT_CODE_DESCRIPTION: `Permet de filtrer la recherche selon le code d'un projet.`,
  PROJECT_DESCRIPTION: `Permet de filtrer la recherche selon un projet.`,
  PROJECT_LOCKED_DESCRIPTION: `Permet de filtrer la recherche selon les utilisateurs verrouillés sur un projet.`,
  PROJECT_OWNER_DESCRIPTION: `Permet de filtrer la recherche selon les chefs de projet.`,
  PROJECT_PREFERRED_DESCRIPTION: `Permet de filtrer la recherche selon les utilisateurs préférés sur un projet.`,
  PROJECT_STATUS_DESCRIPTION: `Permet de filtrer la recherche selon les projets correspondants au statut fourni.`,
  PROJECT_TAG_DESCRIPTION: `Permet de filtrer la recherche selon les étiquettes associées à un projet.`,
  PUNCH_FLAG_DESCRIPTION: "Permet de filtrer la recherche selon l'un des drapeaux suivants.",
  PUNCH_STATUS_DESCRIPTION: `Permet de filtrer la recherche selon le statut de la carte de temps.`,
  REGION_DESCRIPTION: `Permet de filtrer la recherche selon la région du quart.`,
  REPORTS_TO_DESCRIPTION: "Permet de filtrer la recherche selon l'utilisateur responsable d'une équipe.",
  REQUEST_FLAGS_DESCRIPTION: "Permet de filtrer la recherche selon l'avertissement.",
  REQUEST_OPTIONS_DESCRIPTION: `Permet de filtrer les raisons des requêtes d'absences et de congés.`,
  REQUEST_OPTIONS_TYPES_DESCRIPTION: `Permet de filtrer selon les types de raisons.`,
  REQUEST_STATUS_DESCRIPTION: `Permet de filtrer la recherche selon le statut de la demande.`,
  REQUEST_TYPE_DESCRIPTION: `Permet de filtrer la recherche selon le type de requête disponible.`,
  REQUIRES_ACTION_DESCRIPTION: `Les cartes de temps qui nécessitent une action vont être affiché.`,
  RESOURCES_DESCRIPTION: `Permet de filtrer la recherche selon la ressource appliquée sur le quart.`,
  SCHEDULE_EVENT_FLAGS_DESCRIPTION: `Permet de filtrer la recherche selon un indicateur de quart.`,
  SCHEDULE_MODIFICATIONS_REASONS_DESCRIPTION: "Permet de filtrer la recherche selon les raisons ajoutées à une modification de l'horaire.",
  SCHEDULE_TEMPLATES_DESCRIPTION: `Permet d'afficher par quel modèle d'horaire le quart provient.`,
  SCHEDULE_TYPES_DESCRIPTION: `Permet d'afficher les types d'horaires.`,
  SHOW_ALL_POSITIONS_DESCRIPTION: `Utile afin d'afficher tous les quarts avec certain type de congé.`,
  SHOW_CANCELLED_ONLY_DESCRIPTION: `Permet d'afficher uniquement les quarts annulés.`,
  TAG_TYPES_DESCRIPTION: `Permet de filtrer selon les types d'étiquettes.`,
  TAGS_DESCRIPTION: `Filtrer par étiquettes`,
  TEAM_DESCRIPTION: "Permet de filtrer la recherche selon le nom de l'équipe à rechercher.",
  TEMPLATE_NAME_DESCRIPTION: `Permet de filtrer la recherche selon le nom des modèles d'horaires.`,
  USER_DESCRIPTION: "Permet de filtrer la recherche selon le nom ou le numéro d'employé de l'utilisateur à rechercher.",
  USER_ELIGIBLE_FOR_POSITION_DESCRIPTION: "Permet de filtrer la recherche selon les attributs que les utilisateurs à l'horaire possèdent pour cette position.",
  VACATION_TYPE_DESCRIPTION: `Permet de filtrer la recherche selon un type de vacances disponible.`,
  WAGE_PREMIUMS_DESCRIPTION: `Permet de filtrer la recherche selon la prime salariale appliquée sur le quart.`,
  DELETE_PRESET_CONFIRMATION_MODAL: {
    TITLE: `Supprimer une recherche sauvegardée`,
    SUMMARY: `Êtes-vous sûr de vouloir supprimer la recherche sauvegardée {{presetName}} ?`
  },
  HELP_MODAL: {
    TITLE: ``,
    SUMMARY: ``
  },
  punch: {
    ISINEARLY: `Arrivé trop tôt`,
    ISINLATE: `Arrivé trop tard`,
    ISOUTEARLY: `Sorti trop tôt`,
    ISOUTLATE: `Sorti trop tard`,
    FLAG_NOT_PUNCHED_IN: `Pas de poinçon d'arrivé`,
    FLAG_NOT_PUNCHED_OUT: `Pas de poinçon de sortie`,
    FLAG_NO_SHIFT: `Aucun quart associé`,
    FLAG_DUPLICATE_SHIFT: `Carte de temps dupliquée`,
    FLAG_NO_CLOCKED_TIME: `Aucun temps poinçonné`,
    FLAG_LOCATION_CONFLICTS: `Conflits d'emplacement de poinçon`
  },
  contactLists: {
    ARCHIVED: `Archivée`,
    CREATED: `Non démarrée`,
    PAUSED: `En pause`,
    RUNNING: `En cours`
  },
  contactUsers: {
    SHOULDCALL: `Devrait être appelé`,
    SHOULDNOTCALL: `Ne devrait pas être appelé`,
    CALLEDMANUALLY: `Appelé manuellement`,
    NOTCALLEDMANUALLY: `N'a pas été appelé manuellement`,
    NOTCONTACTEDYET: `N'a pas encore été contacté`,
    CONTACTCOMPLETED: `A été contacté`,
    ISINDELAY: `Est dans son délai`,
    HASBEENBUMPED: `N'est pas dans son délai`,
    ACCEPTED: `A accepté un quart`,
    REFUSED: `A refusé tous les quarts`,
    OTHERCHECKNOTES: `Autre, voir notes`
  }
}
